import CalcModel from './data/CalcModel';
import PagesView from './ui/PagesView';
import FormsView from './ui/FormsView';
import Slider from './ui/Slider';
import { dom } from './utils/dom';

class App {
  constructor() {
    dom.grab();
    window.addEventListener('load', () => {
      this.doSliders();

      this.pages = new PagesView();
      this.forms = new FormsView();
      this.model = new CalcModel();
      // coupling for simplicity
      this.pages.forms = this.forms;
      // all loaded show the body
      document.body.style.opacity = 1;

      if (window.gtag) {
        window.gtag('config', 'UA-160260985-1', {
          page_title: 'homepage',
          page_path: '/home'
        });
      }

      const dateParts = document.querySelectorAll(
        '.start-date-form .date-value'
      );

      for (var i = 0; i < dateParts.length; i++) {
        dateParts[i].addEventListener('keydown', function(e) {
          var key = e.keyCode ? e.keyCode : e.which;

          if (
            !(
              [8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
              (key == 65 && (e.ctrlKey || e.metaKey)) ||
              (key >= 35 && key <= 40) ||
              (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
              (key >= 96 && key <= 105)
            )
          )
            e.preventDefault();
        });
      }
    });
  }

  doSliders() {
    window.sliders = [];
    const sliders = document.querySelectorAll('.slider');
    for (let i = 0; i < sliders.length; i++) {
      window.sliders.push(new Slider(sliders[i]));
    }
  }
}

export default App;
